function n(e) {
  if (!e)
    return;
  const t = e.parentElement;
  t && t.removeChild(e);
}
function r(e, t) {
  return (t != null ? t : document.head).querySelector(`style[cssr-id="${e}"]`);
}
function u(e) {
  const t = document.createElement("style");
  return t.setAttribute("cssr-id", e), t;
}
function i(e) {
  return e ? /^\s*@(s|m)/.test(e) : !1;
}
export {
  u as createElement,
  i as isMediaOrSupports,
  r as queryElement,
  n as removeElement
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/css-render@0.15.14/~/css-render/esm/utils.js
// module id = 305
// module chunks = 67